module.exports = __webpack_public_path__ + "img/3-4.ea9901b7.png";